import { render } from "./qualite-certifications.vue?vue&type=template&id=e856f906&scoped=true"
import script from "./qualite-certifications.vue?vue&type=script&lang=js"
export * from "./qualite-certifications.vue?vue&type=script&lang=js"

import "./qualite-certifications.vue?vue&type=style&index=0&id=e856f906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e856f906"]])

export default __exports__